// extracted by mini-css-extract-plugin
export var closeButton = "_m6-1";
export var closeX = "_m6-3";
export var container = "_m6-0";
export var image = "_m6-2";